import { inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import { HttpClient } from '@angular/common/http';
import {
    dtoToModel,
    LocationDTO,
    LocationListResponseDTO,
    LocationRequestDTO,
    LocationTypeListResponseDTO,
} from '@core/dto/location';
import { map, Observable } from 'rxjs';
import { Location } from '@core/models/location.model';

@Injectable({
    providedIn: 'root',
})
export class LocationService {
    readonly #apiUrl = environment.api_url;
    readonly #http = inject(HttpClient);

    getList(): Observable<Array<Location>> {
        return this.#http.get<LocationListResponseDTO>(`${this.#apiUrl}/v2/locations/hubs`)
            .pipe(map(response => response.map(dtoToModel)));
    }

    getLocations() {
        return this.#http.get<LocationListResponseDTO>(`${this.#apiUrl}/v2/locations`);
    }

    getLocation(id: number) {
        return this.#http.get<LocationDTO>(`${this.#apiUrl}/v2/locations/${id}`);
    }

    getLocationTypes() {
        return this.#http.get<LocationTypeListResponseDTO>(`${this.#apiUrl}/v2/locations/type`);
    }

    createLocation(location: LocationRequestDTO) {
        return this.#http.post<LocationDTO>(`${this.#apiUrl}/v2/locations`, location);
    }

    editLocation(location: LocationRequestDTO) {
        return this.#http.put<LocationDTO>(`${this.#apiUrl}/v2/locations/${location.id}`, location);
    }

    deleteLocation(locationId: number) {
        return this.#http.delete<void>(`${this.#apiUrl}/v2/locations/${locationId}`);
    }
}
